// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1h66x","requiredAsterisk":"Info_requiredAsterisk__sddEO"};